import { Constant, EraQL, Expression, ExprVar, Ty } from '@cotera/era';
import { ok } from 'neverthrow';
import { v4 } from 'uuid';

const { c } = EraQL;

const jq: EraQL.SpecialForm = (args, ctx, func) =>
  c
    .Args(c.ExprOfTy('super'), c.StringLit, c.Ty)(args, ctx, func)
    .andThen(([_input, _program, outputTy]) => {
      const expr: Expression = ExprVar.create({
        name: v4(),
        scope: v4(),
        ty: outputTy,
      });

      const item: EraQL.Item = { t: 'expr', expr };
      return ok({ item, bindings: {} });
    });

const fail: EraQL.SpecialForm = (args, ctx, func) =>
  c
    .Args(c.StringLit)(args, ctx, func)
    .map((msg) => ({
      item: { t: 'expr', expr: Constant(msg, { ty: 'string' }) },
      bindings: {},
    }));

const http: EraQL.SpecialForm = (args, ctx, func) =>
  c
    .Args(
      c.ExprOfTy('string'),
      c.StructOf({
        required: {
          outputTy: c.Ty,
        },
        optional: {
          headers: c.RecordOf(c.ExprOfTy('string')),
          method: c.ExprOfTy(Ty.enumOf(['GET', 'POST'])),
          jq: c.ExprOfTy('string'),
        },
        strict: true,
      })
    )(args, ctx, func)
    .andThen(([_domain, { outputTy }]) => {
      const expr: Expression = ExprVar.create({
        name: v4(),
        scope: v4(),
        ty: outputTy.v[0],
      });

      const item: EraQL.Item = { t: 'expr', expr };
      return ok({ item, bindings: {} });
    });

export const BUILTIN_SPECIAL_FORMS: Record<string, EraQL.SpecialForm> = {
  http,
  fail,
  jq,
};
